import React, { Component } from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';

import md5 from 'md5';
import cookie from 'react-cookies';

import config from './config';

import DefaultLayout from './containers/DefaultLayout/';

import Login from './views/Auth/Login';
import Forgotten from './views/Auth/Forgotten';

class Auth extends Component {
 constructor(props) {
  super(props);
  this.state = { uuid: cookie.load('uuid'), token: false };
  this.reqAPI = this.reqAPI.bind(this);
  this.getLogin = this.getLogin.bind(this);
  this.getOut = this.getOut.bind(this);
  this.getUserToken = this.getUserToken.bind(this);

  setInterval(this.getUserToken, 60000);
 }

 reqAPI(route, method, params) {
  var headers = { 'accept': 'application/json' }
  var options = { method: 'GET', headers }
  if(this.state.token) headers['authorization-token'] = this.state.token;

  if(method !== undefined) {
   options = { method, headers, body: JSON.stringify(params) }
  }

  return new Promise((fulfill, reject) => {
   fetch(route, options).then((response) => {
    if (response.status !== 200) throw new Error("Invalid response");
    return response.json()
   }).then((response) => {
    fulfill(response);
   }).catch((error) => {
    reject({success: false, message: error});
   })
  })
 }

 getLogin(email, password) {
  return new Promise((fulfill, reject) => {
   this.reqAPI(config.apiURI+'/api/user/login', 'POST', {email, password: md5(password), uuid: this.state.uuid}).then((response) => {
    if(response.uuid && response.token) {
     const expires = new Date();
     expires.setDate(expires.getDate() + 31);
     cookie.save('uuid', response.uuid, { path: '/', expires });
     this.setState({uuid: response.uuid, token: response.token});
     fulfill(response);
    } else if(response.token) {
     this.setState({token: response.token});
     fulfill(response);
    } else {
     reject(response);
    }
   }).catch((error) => {
    reject(error);
   })
  })
 }

 getOut() {
  this.reqAPI(config.apiURI+'/api/user/logout', 'POST', {token: this.state.token}).then((response) => {
   cookie.remove('uuid', { path: '/' });
   this.setState({uuid: null, token: false});
  })
 }

 getUserToken() {
  this.reqAPI(config.apiURI+'/api/user/token', 'POST', {uuid: this.state.uuid}).then((response) => {
   if(response.token) {
    this.setState({token: response.token});
   } else {
    this.setState({token: false});
   }
  })
 }

 componentDidMount() {
  this._isMounted = true;
  if(this.state.uuid) this.getUserToken();
 }
 
 componentWillUnmount() {
  this._isMounted = false;
 }

 render() {
  return (
   <HashRouter>
   { this.state.uuid && this.state.token ?
    <Switch>
     <Route path="/" render={(props) => <DefaultLayout token={this.state.token} reqAPI={this.reqAPI} getOut={this.getOut} {...props}/>} />
    </Switch>
   :
    <Switch>
     <Route path="/login" render={(props) => <Login getLogin={this.getLogin} {...props}/>} />
     <Route path="/forgotten" render={(props) => <Forgotten reqAPI={this.reqAPI} {...props}/>} />
     <Redirect to="/login"/>
    </Switch>
   }
   </HashRouter>
  )
 }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/auth.js